import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { AlterRowPlainObject, IfCondtionPlainObject } from '../plainObjects/alterRow.plainObject';

export class AlterRowVisitor extends BaseTransformationVisitor {
    private get _alterRowTransformation(): AlterRowPlainObject {
        return this.transformation as AlterRowPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitBasicFunction(functionContext: any): void {
        if (!functionContext.expression(0)) {
            return;
        }

        const ifCondition = new IfCondtionPlainObject();
        ifCondition.expression = functionContext.expression(0).getText();
        ifCondition.conditionType = functionContext.basicName().getText();
        this._alterRowTransformation.conditions.push(ifCondition);
    }
}
